import { render, staticRenderFns } from "./AnfragenDecliend.vue?vue&type=template&id=06a90ee9&scoped=true"
import script from "./AnfragenDecliend.vue?vue&type=script&lang=js"
export * from "./AnfragenDecliend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a90ee9",
  null
  
)

export default component.exports